var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError, retry, switchMap, takeWhile } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { ModalService } from '@ibe/services/ui';
import { INDRASessionTimeoutModalComponent } from '@ibe.components/shared/session-timeout-modal/session-timeout-modal.indra.component';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { Router } from '@angular/router';
import { RETRIES_ON_401 } from '@ibe.config';
import { Store } from '@ngrx/store';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import * as UserActions from '@ibe/store/actions/user.actions';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as fromStore from '../store';
import { PAYMENT_APIS_NO_RETRY } from '@ibe.config';
var ErrorHttpInterceptor = /** @class */ (function () {
    function ErrorHttpInterceptor(modalService, api, router, store, storage) {
        var _this = this;
        this.modalService = modalService;
        this.api = api;
        this.router = router;
        this.store = store;
        this.storage = storage;
        this.user_info$ = this.store.select(fromStore.getUserInfo);
        this.isAlive = true;
        this.user_info$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.userInfo = value;
        });
    }
    ErrorHttpInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        // check first if API URL is excluded for retry
        var excludedAPIsForRetry = false;
        if (req && req.url) {
            for (var i = 0; i < PAYMENT_APIS_NO_RETRY.length; i++) {
                if (req.url.includes(PAYMENT_APIS_NO_RETRY[i])) {
                    excludedAPIsForRetry = true;
                    break;
                }
            }
        }
        if (excludedAPIsForRetry) {
            return next.handle(req).pipe(catchError(function (error) {
                if (error instanceof HttpErrorResponse) {
                    if (error.status == 401) {
                        _this.api.clearSessionToken();
                        _this.modalService.close();
                        _this.modalService.assignComponent(INDRASessionTimeoutModalComponent);
                        _this.modalService.open();
                    }
                    else {
                        return throwError(error);
                    }
                }
                return EMPTY;
            }));
        }
        else {
            return next.handle(req)
                .pipe(retry(1), catchError(function (error) {
                if (error instanceof HttpErrorResponse) {
                    // upon retry of api call if still 401 open session-timeout-modal
                    if (error.status == 401) {
                        if (RETRIES_ON_401 && (_this.router.url === '/booking' || _this.router.url === '/')) {
                            // only applicable on search page
                            _this.clearUserData();
                            return _this.handle401Error(req, next);
                        }
                        else {
                            _this.api.clearSessionToken();
                            _this.modalService.close();
                            _this.modalService.assignComponent(INDRASessionTimeoutModalComponent);
                            _this.modalService.open();
                        }
                    }
                    else {
                        return throwError(error);
                    }
                }
                return EMPTY;
            }));
        }
    };
    ErrorHttpInterceptor.prototype.handle401Error = function (req, next) {
        return this.api.INDRA_retrieveNewToken().pipe(retry(RETRIES_ON_401), switchMap(function (newToken) {
            if (newToken) {
                /*
                if (this.userInfo) {
                    this.callAutomaticLogin();
                }
                */
                var newReq = req.clone({
                    setHeaders: {
                        Authorization: "Bearer " + newToken
                    }
                });
                return next.handle(newReq);
            }
        }), catchError(function () {
            return EMPTY;
        }));
    };
    ErrorHttpInterceptor.prototype.callAutomaticLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.automaticLogin()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // automatically logs in the currently logged in user in case there is a 401 error from the API
    // if login fails, clear user data
    ErrorHttpInterceptor.prototype.automaticLogin = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var loginRequest = {
                flyTapLogin: true,
                flyTapToken: _this.userInfo.flyTapLogin,
                customerId: _this.userInfo.airlineID
            };
            _this.api.INDRA_automaticLogin(loginRequest).subscribe(function (res) {
                var otp = res.otp;
                if (res.status == '200' && res.data) {
                    var _a = res.data, userProfile = _a.userProfile, userPnrs = _a.userPnrs, translate = _a.translate, userAddress = _a.userAddress, defaultCurrency = _a.defaultCurrency;
                    var userData = __assign({}, userProfile, { userPnrs: userPnrs, userAddress: userAddress, translate: translate, userProfile: userProfile, otp: otp });
                    _this.storage.set('userData', userData);
                    var userInfo = __assign({}, userProfile, { defaultCurrency: defaultCurrency });
                    _this.store.dispatch(new UserActions.PutLoggedInAction(true));
                    _this.store.dispatch(new UserActions.PutUserInfoAction(userInfo));
                }
                else {
                    _this.clearUserData();
                }
                resolve(true);
            }, function (error) {
                _this.clearUserData();
                resolve(true);
            });
        });
    };
    ErrorHttpInterceptor.prototype.clearUserData = function () {
        this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
        this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
        this.store.dispatch(new UserActions.PutLoggedInAction(false));
        this.store.dispatch(new UserActions.PutUserInfoAction(false));
        this.store.dispatch(new UserActions.PutCancelLogIn(false));
        this.storage.remove('userData');
        this.storage.remove('user_info');
    };
    return ErrorHttpInterceptor;
}());
export { ErrorHttpInterceptor };
